<template>
  <div class="app-container-v2 table-container-v2">
    <div class="title-box">
      <div class="title-left">
        <span class="title-text">{{ $t('menu.invoiceList') }}</span>
      </div>
    </div>

    <div class="table-body flex vertical" v-loading="loading">
      <air-table
          ref="airTable"
          class="table-v2"
          :show-checkbox="false"
          align="center"
          :columns="columns"
          :data="tableData"
          @change-filter="changeFilter"
      >
        <template #operation="{ row }">
          <div v-if="row.invoiceMedium === '30310002' || row.invoiceMedium === '30310003'" class="flex center mt4">
            <span class="text-button" @click="handleDownload(row)">{{ $t('downloadInvoice') }}</span>
          </div>
        </template>
      </air-table>

      <vxe-pager
          class="pager-v2"
          background
          :current-page.sync="queryParams.page"
          :page-size.sync="queryParams.limit"
          :total="total"
          :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'Sizes', 'Total']"
          @page-change="getData"
      ></vxe-pager>
    </div>
  </div>
</template>

<script>
import * as api from '@/api/v2/service-process/invoice'
import * as apiOrder from '@/api/v2/service-process/order'

export default {
  name: 'ServiceProcessInvoiceList',
  components: {
  },
  data() {
    return {
      loading: true,
      queryParams: {
        page: 1,
        limit: 20,
      },
      total: 0,
      dictMap: {},
      columns: [
        {title: '账单编号', itemEnName: 'Bill number', field: 'billNo', minWidth: 120, filterType: 'input'},
        {title: '发票编号', itemEnName: 'Invoice number', field: 'id', minWidth: 150, filterType: 'input'},
        {title: '发票抬头', itemEnName: 'Invoice title', field: 'invoiceTitleName', minWidth: 150, filterType: 'input'},
        {title: '发票类型', itemEnName: 'Invoice type', field: 'invoiceTypeText', minWidth: 100, filterType: 'select', filterOptions: []},
        {title: '发票介质', itemEnName: 'Invoice media', field: 'invoiceMediumText', minWidth: 100, filterType: 'select', filterOptions: []},
        {title: '总额', itemEnName: 'Total', field: 'amount', money: true, minWidth: 100},
        {title: '备注', itemEnName: 'Remarks', field: 'remark', minWidth: 100},
        {title: '快递单号', itemEnName: 'Express number', field: 'courierNum', minWidth: 100},
        {title: '开票时间', itemEnName: 'Invoice time', field: 'invoiceDate', minWidth: 100},
      ],
      tableData: [],
    }
  },
  computed: {
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.queryParams.cusId = this.$userInfo.cusId
      this.getData()
    },
    getData() {
      this.loading = true
      api.queryInvoiceListByPage(this.queryParams).then(res => {
        const data = res.data.data
        if (!this.dictMap.invoiceType) {
          this.dictMap.invoiceType = this.$arrayToObj(data.invoiceCodeItems['3030'], 'codeItemId')
          this.dictMap.invoiceMedium = this.$arrayToObj(data.invoiceCodeItems['3031'], 'codeItemId')
          this.columns[3].filterOptions = data.invoiceCodeItems['3030']
          this.columns[4].filterOptions = data.invoiceCodeItems['3031']
        }
        this.tableData = this.$handleTableDict(data.invoiceDetailList, this.dictMap)
        this.total = data.params.total
        this.loading = false
      })
    },
    changeFilter(e) {
      this.queryParams = {...this.queryParams, ...e.filterData}
      this.getData()
    },
    handleDownload(row) {
      this.$msgInfo('开始下载...')
      apiOrder.downloadInvoice(row.id).then(res => {
        this.$downloadFile(res)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/air/assets/css/main.scss";
</style>
